import { render, staticRenderFns } from "./BookArtShow.vue?vue&type=template&id=07801fd9&scoped=true&"
import script from "./BookArtShow.vue?vue&type=script&lang=js&"
export * from "./BookArtShow.vue?vue&type=script&lang=js&"
import style0 from "./BookArtShow.vue?vue&type=style&index=0&id=07801fd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07801fd9",
  null
  
)

component.options.__file = "BookArtShow.vue"
export default component.exports